import { Breadcrumb } from '@sgcmpteltd/uikit-react/components/breadcrumb';
import cx from 'clsx';

import styles from './styles.module.scss';
import type { Component } from './types';

export const NewCarBreadcrumb: Component = ({
  className,
  list,
}) => (
  <Breadcrumb
    className={cx(
      styles.breadcrumbRoot,
      styles.breadcrumbResponsive,
      className,
    )}
    list={list} />
);
